export default __webpack_public_path__ + "static/media/use_action_hk.678cd5f7.png";